import { css, html, LitElement, nothing } from 'lit'
import { property, query, state } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-popover')
export class MdcPopover extends LitElement {
  @property({ type: Boolean }) open = false
  @property({ type: Number, attribute: 'anchor-x' }) anchorX = 0
  @property({ type: Number, attribute: 'anchor-y' }) anchorY = 0
  @property({ type: Boolean, attribute: 'no-backdrop' }) noBackdrop = false

  @state() private _x = 0
  @state() private _y = 0

  @query('.mdc-popover__content') private _contentEl!: HTMLElement

  static styles = css`
    :host {
      display: contents;
    }

    .mdc-popover__backdrop {
      position: fixed;
      inset: 0;
      z-index: 99;
    }

    .mdc-popover__content {
      position: fixed;
      z-index: 100;
      filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
    }
  `

  updated(changed: Map<string, unknown>) {
    if (this.open && (changed.has('open') || changed.has('anchorX') || changed.has('anchorY'))) {
      requestAnimationFrame(() => this._clampPosition())
    }
  }

  private _clampPosition() {
    const el = this._contentEl
    if (!el) return

    const w = el.offsetWidth
    const h = el.offsetHeight
    const vw = window.innerWidth
    const vh = window.innerHeight
    const pad = 8

    let x = this.anchorX
    let y = this.anchorY

    if (x + w > vw - pad) x = vw - w - pad
    if (y + h > vh - pad) y = this.anchorY - h
    x = Math.max(pad, x)
    y = Math.max(pad, y)

    this._x = x
    this._y = y
  }

  private _onBackdropClick() {
    this.dispatchEvent(new Event('close'))
  }

  render() {
    if (!this.open) return nothing

    return html`
      ${this.noBackdrop ? nothing : html`<div class="mdc-popover__backdrop" @click=${this._onBackdropClick}></div>`}
      <div class="mdc-popover__content" style="top: ${this._y}px; left: ${this._x}px">
        <slot></slot>
      </div>
    `
  }
}
